<template>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">{{title}}</h2>

            <div class="uk-margin uk-grid">
                <label class="uk-form-label uk-width-1">Craft Name</label>

                <div class="uk-form-controls uk-width-2-3">
                    {{ name }}
                </div>
            </div>
            <div class="uk-grid">
                <div class="uk-form-label uk-width-1-2">Craft Code</div>
                <div class="uk-form-label uk-width-1-4">Hourly Rate</div>
                <div class="uk-width-1-4"></div>
            </div>
            <div v-for="(payCode, index) in payCodes" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-form-controls uk-width-1-2">
                    {{ payCode.code }}
                </div>
                <div class="uk-form-controls uk-width-1-4">
                    {{ payCode.payrate }}
                </div>
                <div class="uk-width-1-4 uk-text-left uk-padding-small" style="padding-bottom: 0;padding-top: 8px;cursor: pointer;">

                </div>
            </div>
            <div class="divider uk-width-3-4 uk-margin-medium-top uk-margin-medium-bottom"></div>
            <div class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-width-1-3">
                    <div class="uk-form-label">Required Certifications</div>
                    <div v-if="certs.length > 0" class="list-box uk-margin-small-top">
                        <div v-for="cert in certs" class="list-box-item">
                            {{ cert.name }}
                            <i class="far fa-trash-alt" @click="dropCert(cert.id)"></i>
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-3">
                    <div class="uk-form-label">Required Trainings</div>
                    <div v-if="trainings.length > 0" class="list-box uk-margin-small-top">
                        <div v-for="training in trainings" class="list-box-item">
                            {{ training.name }}
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-3"><!-- placeholder --></div>
            </div>
            <div class="uk-form-label">Ratings</div>
            <div v-for="(cat, index) in ratingCategories" class="uk-grid uk-margin-small-top uk-margin-small-bottom">
                <div class="uk-width-1-2">
                    {{ cat.name }}
                </div>
                <div class="uk-width-1-4 uk-text-left uk-padding-small" style="padding-bottom: 0;padding-top: 8px;cursor: pointer;" >

                </div>
                <div class="uk-width-1-4"><!-- placeholder --></div>
            </div>
            <div class="uk-margin-large-bottom"></div>

        <button class="uk-button uk-button-primary uk-modal-close" type="button" :uk-toggle="'target: #' + modalId" @click="editForm">Edit</button>
        <button class="uk-button uk-button-tertiary uk-modal-close" type="button">Cancel</button>
    </div>
</template>
<script>
    export default {

        props: {
            modalId:String,
            formRef:String,
            title:{
                type: String,
                default: 'Craft'
            },
        },

        data(){
            return {
                id:null,
                name:"",
                certs:[],
                trainings:[],
                ratingCategories:[{
                    id:null,
                    name:""
                }],
                payCodes:[
                    {
                        id:null,
                        code:"",
                        payrate:null,
                    }
                ],
                get: '/api/craft/get/'
            }
        },

        mounted(){
        },

        methods: {
            editForm(){
                this.$root.$refs[this.formRef].loadForm(this.id);
            },
            clearForm(){
                if(this.id){
                    this.id = null;
                }

            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;
                this.name = data.name;
                this.certs = data.certifications;
                this.trainings = data.trainings;
                this.crafts = data.trainings;
                this.ratingCategories = data.ratingCategories;
                this.payCodes = data.payCodes;
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            }
        },

        watch:{

        }

    }
</script>
<style scoped>
    .uk-grid > *{
        padding-left: 2vw;
    }
    .list-box{
        border: thin solid #707070;
    }
    .list-box-item{
        padding: 5px;
        position: relative;
    }
    .list-box-item i{
        position: absolute;
        right: 5px;
        top: 8px;
    }
</style>
